import axios from './http.js'

let request = {
  status: process.env.NODE_ENV == 'offLine' ? 'offLine' : 'onLine',
  // 获取全量 url: './ssmap/sceneSetting.json'
  get(url, params = {}, method, config = {}) {
    return new Promise((resolve, reject) => {
      if (this.status == 'onLine') {
        axios(url, method, params, config).then((data) => resolve(data)).catch((err) => reject(err))
      } else if (this.status == 'offLine') {
        Native.File.getAbsolutePathAndData(url, (relativePath) => {
          // console.log(url, relativePath, 'relativePath')
          Native.File.readFileAsString(relativePath, true, (fileData) => {
            const data = fileData ? JSON.parse(fileData) : null
            resolve(data)
          })
        })
      }
    })
  },
  // 存储全量 url: './ssmap/sceneSetting.json'
  async set(url, params = {}, method, config = {}) {
    return new Promise((resolve, reject) => {
      if (this.status == 'onLine') {
        axios(url, method, params, config).then((data) => resolve(data)).catch((err) => reject(err))
      } else if (this.status == 'offLine') {
        Native.File.writeFile(url, { isEncode: true, data: JSON.stringify(params) }, () => {
          resolve()
        })
      }
    })
  },
  // 其余后端接口逻辑
  async send(url, method, params, config) {
    return axios(url, method, params, config)
  }
}
export default request
